import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ContractProvider } from '../providers/contract.provider';
import { ProductProvider } from '../providers/product.provider';
import { SelectedProductInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface UpdateSelectedProductsUseCaseParams {
    products: SelectedProductInterface[];
}

@Injectable()
export class UpdateSelectedProductsUseCase implements UseCaseWithParam<UpdateSelectedProductsUseCaseParams, Observable<Transaction<void>>> {
    constructor(private contractProvider: ContractProvider, private productProvider: ProductProvider) {}

    bind(params: UpdateSelectedProductsUseCaseParams): Observable<Transaction<void>> {
        return this.contractProvider.current().pipe(
            switchMap((transaction) =>
                transaction.map(
                    (contract) => this.productProvider.updateSelected(contract.encryptedCode, params.products),
                    (throwable) => of(Transaction.error(throwable.message))
                )
            )
        );
    }
}
